var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _radialGradient, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511 511",
    height: 512,
    viewBox: "0 0 511 511",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    stopColor: "#f0aa76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4808,
    stopColor: "#cf9362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8934,
    stopColor: "#9b6d42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.968,
    x2: 428.694,
    xlinkHref: "#lg1",
    y1: 277.77,
    y2: 277.77
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.327,
    x2: 118.3,
    xlinkHref: "#lg2",
    y1: 336.793,
    y2: 649.326
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.608,
    x2: 264.178,
    xlinkHref: "#lg2",
    y1: 398.369,
    y2: 568.479
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.513,
    x2: 341.171,
    y1: 395.028,
    y2: 604.508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005a01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005a01"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.711,
    x2: 102.261,
    xlinkHref: "#lg2",
    y1: 345.201,
    y2: 195.003
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1876,
    stopColor: "#fdbf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4837,
    stopColor: "#f7a848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#ed835b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.912,
    x2: 358.314,
    xlinkHref: "#lg3",
    y1: 227.685,
    y2: 353.032
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.553,
    x2: 275.581,
    xlinkHref: "#lg1",
    y1: -14.073,
    y2: 89.553
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.657,
    x2: 308.769,
    xlinkHref: "#lg2",
    y1: 40.627,
    y2: 143.139
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.897,
    x2: 249.24,
    xlinkHref: "#lg2",
    y1: 3.459,
    y2: 36.33
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.331,
    x2: 243.331,
    xlinkHref: "#lg3",
    y1: 81.285,
    y2: 97.043
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.23,
    x2: 154.615,
    xlinkHref: "#lg4",
    y1: 480.54,
    y2: 480.54
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.084,
    x2: 161.489,
    xlinkHref: "#lg4",
    y1: 433.321,
    y2: 464.045
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.318,
    x2: 93.004,
    xlinkHref: "#lg5",
    y1: 446.719,
    y2: 387.771
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.19,
    x2: 146.069,
    xlinkHref: "#lg4",
    y1: 461.314,
    y2: 529.682
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.103,
    x2: 62.97,
    xlinkHref: "#lg5",
    y1: 500.999,
    y2: 440.047
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.713,
    x2: 295.098,
    xlinkHref: "#lg4",
    y1: 480.54,
    y2: 480.54
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.567,
    x2: 301.972,
    xlinkHref: "#lg4",
    y1: 433.321,
    y2: 464.045
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.801,
    x2: 233.487,
    xlinkHref: "#lg5",
    y1: 446.719,
    y2: 387.771
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.673,
    x2: 286.552,
    xlinkHref: "#lg4",
    y1: 461.314,
    y2: 529.682
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.586,
    x2: 203.453,
    xlinkHref: "#lg5",
    y1: 500.999,
    y2: 440.047
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.921,
    x2: 272.685,
    xlinkHref: "#lg6",
    y1: 431.753,
    y2: 243.814
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.33,
    x2: 425.715,
    xlinkHref: "#lg4",
    y1: 480.54,
    y2: 480.54
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.184,
    x2: 432.589,
    xlinkHref: "#lg4",
    y1: 433.321,
    y2: 464.045
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.418,
    x2: 364.104,
    xlinkHref: "#lg5",
    y1: 446.719,
    y2: 387.77
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.29,
    x2: 417.169,
    xlinkHref: "#lg4",
    y1: 461.314,
    y2: 529.682
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.203,
    x2: 334.07,
    xlinkHref: "#lg5",
    y1: 500.999,
    y2: 440.047
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.553,
    x2: 325.244,
    xlinkHref: "#lg7",
    y1: 479.077,
    y2: 327.991
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.431,
    x2: 359.816,
    xlinkHref: "#lg4",
    y1: 423.477,
    y2: 423.477
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.285,
    x2: 366.69,
    xlinkHref: "#lg4",
    y1: 376.257,
    y2: 406.981
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.519,
    x2: 298.205,
    xlinkHref: "#lg5",
    y1: 389.655,
    y2: 330.707
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.39,
    x2: 351.27,
    xlinkHref: "#lg4",
    y1: 404.25,
    y2: 472.618
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.304,
    x2: 268.171,
    xlinkHref: "#lg5",
    y1: 443.935,
    y2: 382.983
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -2572.834 1296.452)",
    gradientUnits: "userSpaceOnUse",
    x1: 1158.378,
    x2: 1173.831,
    xlinkHref: "#lg4",
    y1: -2897.012,
    y2: -2897.012
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(.707 -.707 .707 .707 989.74 -536.954)",
    gradientUnits: "userSpaceOnUse",
    x1: -923.384,
    x2: -909.191,
    xlinkHref: "#lg7",
    y1: -59.359,
    y2: -28.424
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(.707 -.707 .707 .707 989.74 -536.954)",
    gradientUnits: "userSpaceOnUse",
    x1: -929.678,
    x2: -914.253,
    xlinkHref: "#lg7",
    y1: -59.891,
    y2: -25.218
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    stopColor: "#fee038",
    stopOpacity: 0.442
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(.707 -.707 .707 .707 989.74 -536.954)",
    gradientUnits: "userSpaceOnUse",
    x1: -916.611,
    x2: -924.628,
    xlinkHref: "#lg8",
    y1: -52.443,
    y2: -76.74
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -2827.912 -3916.561)",
    gradientUnits: "userSpaceOnUse",
    x1: 613.307,
    x2: 628.759,
    xlinkHref: "#lg4",
    y1: -5044.964,
    y2: -5044.964
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -994.506 -353.987)",
    gradientUnits: "userSpaceOnUse",
    x1: 1224.569,
    x2: 1238.762,
    xlinkHref: "#lg7",
    y1: -604.431,
    y2: -573.495
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -994.506 -353.987)",
    gradientUnits: "userSpaceOnUse",
    x1: 1218.274,
    x2: 1233.699,
    xlinkHref: "#lg7",
    y1: -604.963,
    y2: -570.29
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -994.506 -353.987)",
    gradientUnits: "userSpaceOnUse",
    x1: 1231.342,
    x2: 1223.325,
    xlinkHref: "#lg8",
    y1: -597.514,
    y2: -621.812
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_41_",
    cx: 282.87,
    cy: 78.946,
    gradientUnits: "userSpaceOnUse",
    r: 16.787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#ffd744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6278,
    stopColor: "#ffcf3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7926,
    stopColor: "#ffc237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    stopColor: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.091,
    x2: 272.974,
    xlinkHref: "#lg5",
    y1: 86.46,
    y2: 70.343
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.473,
    x2: 317.571,
    xlinkHref: "#lg7",
    y1: 84.626,
    y2: 63.383
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.75,
    x2: 286.75,
    xlinkHref: "#lg6",
    y1: 79.976,
    y2: 67.272
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3386,
    stopColor: "#47b071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5502,
    stopColor: "#3fa870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309b6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#1c8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  }))), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.273,
    x2: 454.434,
    xlinkHref: "#lg9",
    y1: 199.453,
    y2: 199.453
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.98,
    x2: 81.141,
    xlinkHref: "#lg9",
    y1: 213.333,
    y2: 213.333
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.995,
    x2: 391.853,
    xlinkHref: "#lg9",
    y1: 138.622,
    y2: 138.622
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.911,
    x2: 487.769,
    xlinkHref: "#lg9",
    y1: 94.138,
    y2: 94.138
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.211,
    x2: 116.069,
    xlinkHref: "#lg9",
    y1: 102.446,
    y2: 102.446
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.798 248.2-13.376-70.151c-9.977-52.325-55.729-90.177-108.997-90.177h-50.187c-53.268 0-99.019 37.852-108.997 90.177l-7.584 39.773c-7.288 38.221-18.938 75.614-36.361 110.405-5.094 10.172-7.769 21.764-7.268 34.028 1.449 35.482 32.677 66.012 68.181 66.706.26.005.52.009.78.011 16.108.139 31.618 6.417 42.914 17.901 12.626 12.835 30.188 20.796 49.616 20.796 23.579 0 44.414-11.722 57.01-29.654 4.055-5.773 10.706-9.054 17.76-9.04h.122c3.031 0 6.009-.225 8.92-.656 5.49-.813 11.043.588 15.574 3.792 12.255 8.669 27.431 13.481 43.767 12.654 34.961-1.769 63.48-29.755 65.855-64.68.855-12.567-1.631-24.477-6.655-34.938-14.743-30.705-24.695-63.489-31.074-96.947z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 127.604,
    cy: 359.339,
    fill: "url(#SVGID_2_)",
    r: 69.636
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.52,
    cy: 398.033,
    fill: "url(#SVGID_3_)",
    r: 69.636
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.058,
    cy: 375.221,
    fill: "url(#SVGID_4_)",
    r: 69.636
  })), /*#__PURE__*/React.createElement("path", {
    d: "m283.789 169.846c-5.042-1.559-9.832-2.683-14.368-3.375-2.189-.335-4.399-.605-6.627-.819-.018-.01-.036-.02-.054-.03l-10.208-10.573c-2.016-1.316-4.203-1.977-6.554-1.977-2.691 0-4.959.627-6.806 1.871-1.85 1.248-2.773 2.73-2.773 4.439v6.546c-14.62 2.056-26.679 7.456-36.171 16.196-9.497 8.739-14.242 20.732-14.242 35.983 0 6.219 1.091 11.891 3.276 17.015 2.182 5.128 4.704 9.326 7.563 12.603l39.574 39.611v23.533c-6.554-1.174-13.698-4.494-21.425-9.957-7.732-5.459-13.194-8.193-16.385-8.193-4.537 0-8.53 2.355-11.973 7.058-3.445 4.707-5.167 9.414-5.167 14.116 0 6.129 3.007 11.791 9.011 16.988l98.683 98.683c1.669-.391 3.396-.592 5.148-.588h.122c3.031 0 6.009-.225 8.92-.656 5.49-.813 11.043.588 15.574 3.792 12.255 8.669 27.431 13.481 43.767 12.654 34.961-1.769 63.48-29.755 65.855-64.68.854-12.566-1.631-24.476-6.655-34.938-10.262-21.37-18.197-43.748-24.227-66.658l-101.633-101.634c-3.112-3.115-7.183-5.45-12.225-7.01z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.064 272.804c-2.104-5.377-4.624-9.831-7.562-13.36-2.943-3.529-6.849-6.889-11.722-10.083-4.875-3.19-9.243-5.628-13.107-7.31-3.867-1.678-8.569-3.612-14.115-5.798v-36.802c6.049.504 11.886 2.186 17.518 5.041 5.628 2.859 9.618 4.285 11.973 4.285 4.872 0 8.696-2.391 11.47-7.172 2.772-4.782 4.159-9.398 4.159-13.84 0-4.155-1.555-7.79-4.663-10.91-3.112-3.116-7.183-5.451-12.225-7.011-5.041-1.56-9.832-2.683-14.368-3.375-4.537-.693-9.162-1.127-13.863-1.3v-5.817c0-1.552-1.009-2.985-3.026-4.305-2.016-1.316-4.203-1.977-6.554-1.977-2.691 0-4.959.626-6.806 1.871-1.85 1.248-2.773 2.729-2.773 4.439v6.546c-14.62 2.056-26.679 7.456-36.171 16.196-9.497 8.739-14.242 20.732-14.242 35.983 0 6.219 1.091 11.891 3.275 17.015 2.182 5.128 4.704 9.326 7.564 12.603 2.855 3.277 6.889 6.471 12.099 9.579 5.207 3.111 9.579 5.419 13.107 6.932 3.529 1.513 8.318 3.447 14.367 5.798v40.836c-6.554-1.174-13.698-4.494-21.425-9.957-7.732-5.459-13.194-8.193-16.385-8.193-4.537 0-8.53 2.355-11.973 7.058-3.445 4.707-5.167 9.414-5.167 14.116 0 8.236 5.419 15.628 16.259 22.182 10.839 6.554 23.734 10.082 38.692 10.587v6.302c0 1.847.923 3.442 2.773 4.789 1.847 1.343 4.116 2.016 6.806 2.016 2.351 0 4.538-.716 6.554-2.143 2.017-1.43 3.026-2.985 3.026-4.663v-7.31c15.124-2.52 27.179-8.484 36.171-17.897 8.988-9.409 13.486-21.761 13.486-37.054-.002-6.554-1.052-12.517-3.152-17.897zm-63.143-42.6c-10.756-4.537-16.133-9.83-16.133-15.88 0-7.223 5.377-11.93 16.133-14.116zm14.114 80.41v-33.777c10.248 4.876 15.377 10.839 15.377 17.897 0 8.235-5.128 13.529-15.377 15.88z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.533 87.872h-68.404l-31.121-59.66c-4.594-8.807.651-19.546 10.421-21.338l20.38-3.737c22.824-4.185 46.218-4.185 69.042 0l20.38 3.737c9.771 1.791 15.016 12.53 10.421 21.338z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.706 87.872h-22.75l-10.35-59.66c-1.528-8.807.217-19.546 3.466-21.338l6.778-3.737c7.591-4.185 15.372-4.185 22.962 0l6.778 3.737c3.25 1.791 4.994 12.53 3.466 21.338z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.626 12.878c1.334 1.897.662 4.541-1.406 5.589-9.705 4.936-21.182 4.936-30.887 0l-8.58-4.357c-9.705-4.936-21.182-4.936-30.887 0l-8.569 4.357c-9.705 4.936-21.182 4.936-30.887 0l-8.975-4.565c-3.144-1.599-2.559-6.355.908-7.007.029-.006.059-.011.088-.016l20.38-3.744c22.82-4.179 46.219-4.179 69.039 0l20.38 3.744c4.025.735 7.277 2.986 9.396 5.999z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m243.331 94.56c-14.828 0-28.863-.958-40.364-2.728-3.788-.583-6.329-4.194-5.565-7.95.711-3.492 4.028-5.817 7.551-5.277 10.803 1.656 24.392 2.583 38.378 2.583s27.575-.927 38.378-2.583c3.523-.54 6.84 1.784 7.551 5.277.764 3.756-1.777 7.367-5.565 7.95-11.501 1.77-25.536 2.728-40.364 2.728z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m147.838 511h-117.831c-4.351 0-7.574-4.043-6.603-8.285l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.969 4.242-2.254 8.285-6.605 8.285z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.219 413.113c1.376-1.563 2.041-3.742 1.529-5.982l-9.809-42.885c-1.305-5.704-6.379-9.749-12.231-9.749h-86.959c-4.923 0-9.287 2.869-11.328 7.175l-79.013 93.428c-1.031 1.373-1.793 2.972-2.196 4.73l-9.809 42.885c-.97 4.242 2.253 8.285 6.603 8.285h117.832c2.981 0 5.431-1.899 6.367-4.458z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.939 364.245c-.051-.222-.117-.436-.179-.653-1.479-.608-3.086-.949-4.762-.949h-86.959c-4.923 0-9.287 2.869-11.328 7.175l-79.014 93.429c-1.031 1.373-1.793 2.972-2.196 4.73l-9.809 42.885c-.01.046-.014.092-.023.138h117.169c2.981 0 5.431-1.899 6.367-4.458l79.013-93.428c1.376-1.563 2.041-3.742 1.529-5.982z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.838 511h-117.831c-4.351 0-7.574-4.043-6.603-8.285l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.969 4.242-2.254 8.285-6.605 8.285z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.633 459.83c-.148-.648-.351-1.271-.592-1.872-1.455-.586-3.033-.915-4.677-.915h-86.959c-5.852 0-10.926 4.045-12.231 9.749l-9.809 42.885c-.102.445-.147.886-.16 1.322h117.633c4.351 0 7.574-4.043 6.604-8.284z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m288.321 511h-117.831c-4.351 0-7.574-4.043-6.604-8.285l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.97 4.242-2.253 8.285-6.604 8.285z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.702 413.113c1.376-1.563 2.041-3.742 1.529-5.982l-9.809-42.885c-1.305-5.704-6.379-9.749-12.231-9.749h-86.959c-4.923 0-9.287 2.869-11.328 7.175l-79.013 93.428c-1.031 1.373-1.793 2.972-2.196 4.73l-9.809 42.885c-.97 4.242 2.253 8.285 6.604 8.285h117.831c2.981 0 5.431-1.899 6.367-4.458z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.422 364.245c-.051-.222-.117-.436-.179-.653-1.479-.608-3.086-.949-4.763-.949h-86.959c-4.923 0-9.287 2.869-11.327 7.175l-79.014 93.429c-1.031 1.373-1.793 2.972-2.195 4.73l-9.809 42.885c-.011.046-.014.092-.023.138h117.169c2.981 0 5.431-1.899 6.367-4.458l79.013-93.428c1.376-1.563 2.041-3.742 1.529-5.982z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.321 511h-117.831c-4.351 0-7.574-4.043-6.604-8.285l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.97 4.242-2.253 8.285-6.604 8.285z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.116 459.83c-.148-.648-.351-1.271-.592-1.872-1.455-.586-3.033-.915-4.677-.915h-86.959c-5.852 0-10.926 4.045-12.231 9.749l-9.809 42.885c-.102.445-.148.886-.161 1.322h117.633c4.351 0 7.574-4.043 6.603-8.284z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.422 364.245c-.665-2.906-2.311-5.377-4.537-7.106l-183.268 95.92-1.726 2.041c-1.031 1.373-1.793 2.972-2.195 4.73l-9.809 42.885c-.97 4.241 2.253 8.284 6.604 8.284h117.831c2.981 0 5.431-1.899 6.367-4.458l79.013-93.428c1.376-1.563 2.041-3.742 1.529-5.982z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.938 511h-117.831c-4.351 0-7.574-4.043-6.604-8.285l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.97 4.242-2.253 8.285-6.604 8.285z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.319 413.113c1.376-1.563 2.041-3.742 1.529-5.982l-9.809-42.885c-1.305-5.704-6.379-9.749-12.231-9.749h-86.959c-4.923 0-9.287 2.869-11.327 7.175l-79.014 93.428c-1.031 1.373-1.793 2.972-2.196 4.73l-9.809 42.885c-.97 4.242 2.253 8.285 6.604 8.285h117.831c2.981 0 5.431-1.899 6.367-4.458z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.039 364.245c-.051-.222-.117-.436-.179-.653-1.478-.608-3.086-.949-4.763-.949h-86.959c-4.923 0-9.287 2.869-11.327 7.175l-79.014 93.429c-1.031 1.373-1.793 2.972-2.195 4.73l-9.809 42.885c-.011.046-.014.092-.023.138h117.169c2.981 0 5.431-1.899 6.367-4.458l79.014-93.428c1.376-1.563 2.041-3.742 1.529-5.982z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.938 511h-117.831c-4.351 0-7.574-4.043-6.604-8.285l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.97 4.242-2.253 8.285-6.604 8.285z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.733 459.83c-.148-.648-.351-1.271-.592-1.872-1.455-.586-3.033-.915-4.677-.915h-86.959c-5.852 0-10.926 4.045-12.231 9.749l-9.809 42.885c-.102.445-.147.886-.16 1.322h117.633c4.351 0 7.574-4.043 6.603-8.284z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m439.265 354.539.026-.043h-42.443c-4.923 0-9.287 2.869-11.327 7.175l-16.285 19.255-3.815-16.681c-1.305-5.704-6.379-9.749-12.231-9.749h-75.76l-36.822 43.54c-1.031 1.373-1.794 2.972-2.196 4.73l-9.809 42.885c-.674 2.946.678 5.793 3.022 7.259l57.966 57.966c2.393-.452 4.297-2.151 5.096-4.336l.035-.042c.924 2.581 3.386 4.5 6.383 4.5h117.831c2.981 0 5.431-1.899 6.367-4.458l76.044-89.917z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.039 453.936h-117.832c-4.351 0-7.574-4.043-6.604-8.284l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.97 4.241-2.252 8.284-6.603 8.284z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.42 356.049c1.376-1.563 2.041-3.742 1.529-5.983l-9.809-42.885c-1.305-5.704-6.379-9.749-12.231-9.749h-86.959c-4.923 0-9.287 2.869-11.328 7.175l-79.014 93.429c-1.031 1.373-1.794 2.972-2.196 4.73l-9.809 42.885c-.97 4.241 2.253 8.285 6.604 8.285h117.831c2.981 0 5.431-1.899 6.367-4.458z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.139 307.181c-.051-.222-.117-.437-.179-.653-1.478-.608-3.086-.949-4.763-.949h-86.959c-4.923 0-9.287 2.869-11.328 7.175l-79.014 93.429c-1.031 1.373-1.793 2.972-2.195 4.73l-9.809 42.885c-.011.046-.014.092-.023.138h117.169c2.981 0 5.431-1.899 6.367-4.458l79.014-93.428c1.376-1.563 2.041-3.742 1.529-5.983z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.039 453.936h-117.832c-4.351 0-7.574-4.043-6.604-8.284l9.809-42.885c1.305-5.704 6.379-9.749 12.231-9.749h86.959c5.852 0 10.926 4.045 12.231 9.749l9.809 42.885c.97 4.241-2.252 8.284-6.603 8.284z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.833 402.766c-.148-.648-.351-1.271-.592-1.872-1.455-.586-3.033-.915-4.677-.915h-86.959c-5.852 0-10.926 4.045-12.231 9.749l-9.809 42.885c-.102.445-.147.886-.16 1.322h117.633c4.351 0 7.574-4.043 6.604-8.284z",
    fill: "url(#SVGID_32_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m314.204 69.445-17.092 17.091c-3.017 3.017-7.909 3.017-10.926 0s-3.017-7.909 0-10.926l17.092-17.092c3.017-3.017 7.909-3.017 10.926 0s3.018 7.909 0 10.927z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.003 61.985c1.826 1.826 3.13 3.975 3.913 6.263 1.174 3.431.249 7.234-2.315 9.799l-8.346 8.346c-3.061 3.061-8.167 3.156-11.171.038-2.913-3.024-2.879-7.838.103-10.82l15.529-15.529c.807.551 1.573 1.189 2.287 1.903z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.428 70.56c2.206 2.206 3.651 4.885 4.335 7.709.681 2.813-.161 5.778-2.208 7.824l-.3.3c-3.061 3.061-8.167 3.156-11.171.038-2.913-3.024-2.879-7.838.103-10.82l6.955-6.955c.807.552 1.572 1.19 2.286 1.904z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.34 58.846-17.092 17.092c-3.017 3.017-3.017 7.909 0 10.926.909.909 1.99 1.539 3.137 1.901 1.725-.164 3.406-.907 4.727-2.228l17.092-17.091c3.017-3.017 3.017-7.909 0-10.926-.909-.909-1.99-1.539-3.137-1.901-1.725.163-3.406.905-4.727 2.227z",
    fill: "url(#SVGID_36_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m303.333 103.875-17.092-17.092c-3.017-3.017-3.017-7.909 0-10.926s7.909-3.017 10.926 0l17.092 17.091c3.017 3.017 3.017 7.909 0 10.926-3.017 3.018-7.909 3.018-10.926.001z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.792 93.674c-1.826 1.826-3.975 3.13-6.263 3.913-3.431 1.174-7.234.249-9.799-2.315l-8.346-8.346c-3.061-3.061-3.156-8.167-.038-11.171 3.024-2.913 7.838-2.879 10.82.103l15.529 15.529c-.551.807-1.188 1.572-1.903 2.287z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.217 85.099c-2.206 2.206-4.884 3.651-7.709 4.335-2.813.681-5.777-.161-7.824-2.208l-.3-.3c-3.061-3.061-3.156-8.167-.038-11.171 3.024-2.913 7.838-2.879 10.82.103l6.955 6.955c-.551.806-1.189 1.572-1.904 2.286z",
    fill: "url(#SVGID_39_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.932 96.011-17.092-17.092c-3.017-3.017-7.909-3.017-10.926 0-.909.909-1.539 1.99-1.901 3.137.164 1.725.907 3.406 2.228 4.727l17.092 17.092c3.017 3.017 7.909 3.017 10.926 0 .909-.909 1.539-1.99 1.901-3.137-.164-1.725-.907-3.406-2.228-4.727z",
    fill: "url(#SVGID_40_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 286.75,
    cy: 84.12,
    fill: "url(#SVGID_41_)",
    r: 13.473
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.75,
    cy: 84.12,
    fill: "url(#SVGID_42_)",
    r: 12.026
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.777 72.068c.909 1.813 1.421 3.86 1.421 6.027 0 7.441-6.032 13.473-13.473 13.473-2.167 0-4.213-.512-6.027-1.421 2.212 4.415 6.777 7.446 12.052 7.446 7.441 0 13.473-6.032 13.473-13.473 0-5.275-3.031-9.84-7.446-12.052z",
    fill: "url(#SVGID_43_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m295.86 78.354c0 3.457-4.079 6.26-9.11 6.26s-9.11-2.803-9.11-6.26 4.079-6.26 9.11-6.26c5.031-.001 9.11 2.802 9.11 6.26z",
    fill: "url(#SVGID_44_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.298 203.493c-12.806 8.346-23.733 19.338-32.007 32.197-1.861 2.892-6.155 2.884-8.005-.015-8.227-12.889-19.114-23.921-31.889-32.313-2.836-1.863-2.828-6.098.014-7.951 12.806-8.345 23.733-19.337 32.007-32.197 1.861-2.892 6.155-2.884 8.005.014 8.228 12.889 19.114 23.921 31.89 32.313 2.835 1.865 2.827 6.1-.015 7.952z",
    fill: "url(#SVGID_45_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.004 217.374c-12.806 8.346-23.733 19.338-32.007 32.197-1.861 2.892-6.155 2.884-8.005-.015-8.227-12.889-19.114-23.921-31.889-32.313-2.836-1.863-2.828-6.098.014-7.951 12.806-8.345 23.733-19.338 32.007-32.197 1.861-2.892 6.155-2.884 8.005.014 8.228 12.889 19.114 23.921 31.89 32.313 2.835 1.864 2.828 6.1-.015 7.952z",
    fill: "url(#SVGID_46_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.342 141.479c-9.056 5.902-16.783 13.675-22.634 22.768-1.316 2.045-4.353 2.039-5.661-.01-5.818-9.115-13.516-16.916-22.551-22.851-2.005-1.317-2-4.313.01-5.622 9.056-5.902 16.783-13.675 22.634-22.768 1.316-2.045 4.353-2.039 5.661.01 5.818 9.115 13.517 16.916 22.551 22.851 2.006 1.317 2.001 4.312-.01 5.622z",
    fill: "url(#SVGID_47_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.258 96.995c-9.056 5.902-16.783 13.675-22.634 22.768-1.316 2.045-4.353 2.039-5.661-.01-5.818-9.115-13.516-16.916-22.551-22.851-2.005-1.317-2-4.313.01-5.622 9.056-5.901 16.783-13.675 22.634-22.768 1.316-2.045 4.353-2.039 5.661.01 5.818 9.115 13.517 16.916 22.551 22.851 2.006 1.317 2 4.312-.01 5.622z",
    fill: "url(#SVGID_48_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.558 105.303c-9.056 5.902-16.783 13.675-22.634 22.769-1.316 2.045-4.353 2.039-5.661-.01-5.818-9.115-13.516-16.916-22.551-22.851-2.005-1.317-2-4.312.01-5.622 9.056-5.902 16.783-13.675 22.634-22.768 1.316-2.045 4.353-2.039 5.661.01 5.818 9.115 13.517 16.916 22.551 22.851 2.006 1.316 2 4.311-.01 5.621z",
    fill: "url(#SVGID_49_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoneyBag);
export default __webpack_public_path__ + "static/media/icon-money-bag.80709abd69af870ab8de87dc1bf8c52c.svg";
export { ForwardRef as ReactComponent };